'use strict';

const base = require('base/product/base');
const productImageResolver = require('../utils/productImageResolver');

// processInclude can run these initializers more than once per page, and webpack scope
// hoisting can even inline this module into several chunks of the same bundle - so a plain
// $(document).on(...) ends up bound twice and a single swatch click fires two identical
// Product-Variation calls. Bind through a namespace and clear it first so the net result is
// always exactly one handler, whatever the number of module copies / init passes.
function colorAttribute() {
	$(document)
		.off('click.lvzColorAttribute', '[data-attr="color"] button')
		.on('click.lvzColorAttribute', '[data-attr="color"] button', function (e) {
			e.preventDefault();

			if ($(this).attr('disabled')) {
				return;
			}
			let $productContainer = $(this).closest('.set-item');
			if (!$productContainer.length) {
				$productContainer = $(this).closest('.product-detail');
			}

			$productContainer.find('[data-attr="color"] button').removeClass('disabled-swatch');
			$(this).addClass('disabled-swatch');

			$('body').data('lvz-swatch-gallery-update', true);
			base.attributeSelect($(this).attr('data-url'), $productContainer);
		});
}

base.colorAttribute = colorAttribute;

function selectAttribute() {
	const selector = '.product-detail select[class*="select-"], .set-item select[class*="select-"], .product-detail .options-select, .set-item .options-select';

	$(document)
		.off('change.lvzSelectAttribute', selector)
		.on('change.lvzSelectAttribute', selector, function (e) {
			e.preventDefault();

			let $productContainer = $(this).closest('.set-item');
			if (!$productContainer.length) {
				$productContainer = $(this).closest('.product-detail');
			}
			base.attributeSelect(e.currentTarget.value, $productContainer);
		});
}

base.selectAttribute = selectAttribute;

function syncBonusQtyStepper($select) {
	if (!$select || !$select.length) {
		return;
	}
	const $wrap = $select.closest('.bonus-quantity');
	if (!$wrap.length) {
		return;
	}
	const maxQty = parseInt($('#chooseBonusProductModal .choose-bonus-product-dialog').data('total-qty'), 10);
	let selectedQty = 0;
	$('#chooseBonusProductModal .selected-bonus-products .selected-pid').each(function () {
		selectedQty += parseInt($(this).data('qty'), 10) || 0;
	});
	const allowedQty = !isNaN(maxQty) ? Math.max(maxQty - selectedQty, 1) : null;
	if (allowedQty !== null) {
		const selectedValue = parseInt($select.val(), 10) || 1;
		if (selectedValue > allowedQty) {
			let fallbackIndex = 0;
			$select.find('option').each(function (index) {
				if ((parseInt($(this).val(), 10) || 0) <= allowedQty) {
					fallbackIndex = index;
				}
			});
			$select.prop('selectedIndex', fallbackIndex);
		}
	}
	const idx = $select.prop('selectedIndex');
	const maxIdx = $select.find('option').length - 1;
	const $opt = $select.find('option:selected');
	const currentQty = parseInt($opt.val(), 10) || 0;
	$wrap.find('.bonus-qty-display').text($opt.length ? $opt.val() : '');
	$wrap.find('.bonus-qty-minus').prop('disabled', idx <= 0);
	$wrap.find('.bonus-qty-plus').prop('disabled', maxIdx < 0 || idx >= maxIdx || (allowedQty !== null && currentQty >= allowedQty));
}

function syncAllBonusQtySteppers($root) {
	const $ctx = $root && $root.length ? $root : $(document);
	$ctx.find('select.bonus-quantity-select').each(function () {
		syncBonusQtyStepper($(this));
	});
}

/**
 * Keeps bonus gift qty steppers aligned with the max bonus allowance.
 */
function bindBonusQtySteppers() {
	$(document)
		.off('change.lvzBonusQtyStepper', '.bonus-quantity-select')
		.on('change.lvzBonusQtyStepper', '.bonus-quantity-select', function () {
			const $select = $(this);
			syncBonusQtyStepper($select);
		});
}

/**
 * Shows/hides the max bonus quantity alert in the choose-bonus modal footer.
 * @param {boolean} visible
 */
function setBonusMaxQtyMessage(visible) {
	const $msg = $('#chooseBonusProductModal .choose-bonus-max-qty');
	if (!$msg.length) {
		return;
	}
	if (visible) {
		$msg.removeClass('d-none').addClass('show-error');
	} else {
		$msg.removeClass('show-error').addClass('d-none');
	}

}

/**
 * Parses the html for a modal window (SFRA parseHtml is private).
 * @param {string} html
 * @returns {{ body: JQuery, footer: JQuery }}
 */
function parseBonusModalHtml(html) {
	const $html = $('<div>').append($.parseHTML(html));
	return {
		body: $html.find('.choice-of-bonus-product'),
		footer: $html.find('.modal-footer').children(),
	};
}

function stopBonusModalLoader() {
	if ($.spinner && $.spinner().forceStop) {
		$.spinner().forceStop();
	}
}

/**
 * Lavazza override of SFRA chooseBonusProducts: close uses icon-close.
 * @param {Object} data - bonus discount line item payload
 */
function chooseBonusProducts(data) {
	if ($('#chooseBonusProductModal').length !== 0) {
		$('#chooseBonusProductModal').remove();
	}

	const bonusUrl = data.bonusChoiceRuleBased
		? data.showProductsUrlRuleBased
		: data.showProductsUrlListBased;

	const htmlString = '<!-- Modal -->'
		+ '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
		+ '<span class="enter-message sr-only" ></span>'
		+ '<div class="modal-dialog choose-bonus-product-dialog" '
		+ 'data-total-qty="' + data.maxBonusItems + '"'
		+ 'data-UUID="' + data.uuid + '"'
		+ 'data-pliUUID="' + data.pliUUID + '"'
		+ 'data-addToCartUrl="' + data.addToCartUrl + '"'
		+ 'data-pageStart="0"'
		+ 'data-pageSize="' + data.pageSize + '"'
		+ 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
		+ 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
		+ '<!-- Modal content-->'
		+ '<div class="modal-content">'
		+ '<div class="modal-header">'
		+ '    <span class="">' + data.labels.selectprods + '</span>'
		+ '    <button type="button" class="close pull-right" data-dismiss="modal" data-no-loader data-lvz-no-loader>'
		+ '        <i class="icon-close text-2xl" aria-hidden="true"></i>'
		+ '        <span class="sr-only"> </span>'
		+ '    </button>'
		+ '</div>'
		+ '<div class="modal-body"></div>'
		+ '<div class="modal-footer"></div>'
		+ '</div>'
		+ '</div>'
		+ '</div>';
	$('body').append(htmlString);

	$.ajax({
		lvzSkipAutoSpinner: true,
		url: bonusUrl,
		method: 'GET',
		dataType: 'json',
		success: function (response) {
			const parsedHtml = parseBonusModalHtml(response.renderedTemplate);
			$('#chooseBonusProductModal .modal-body').empty();
			$('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
			$('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
			$('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
			$('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
			stopBonusModalLoader();
			$('#chooseBonusProductModal').modal('show');
		},
		error: function () {
			stopBonusModalLoader();
		},
	});
}

base.methods = Object.assign({}, base.methods, {
	editBonusProducts: function (data) {
		chooseBonusProducts(data);
	},
});

/**
 * SFRA handlePostCartAdd closes over private chooseBonusProducts; swap close icon for that path.
 * @param {JQuery} $modal
 */
function ensureBonusModalCloseIcon($modal) {
	const $close = $modal.find('.modal-header .close');
	if (!$close.length || $close.find('.icon-close').length) {
		return;
	}
	const closeLabel = $close.find('.sr-only').text() || ' ';
	$close.html(
		'<i class="icon-close text-2xl" aria-hidden="true"></i>'
		+ '<span class="sr-only">' + closeLabel + '</span>'
	);
}

/**
 * Move subtitle into the modal header and sync qty steppers once the bonus modal is shown.
 */
function enhanceChooseBonusProductModal() {
	$('body')
		.off('shown.bs.modal.lvzChooseBonusProduct hidden.bs.modal.lvzChooseBonusProduct', '#chooseBonusProductModal')
		.on('shown.bs.modal.lvzChooseBonusProduct', '#chooseBonusProductModal', function () {
			const $modal = $(this);
			const $intro = $modal.find('.modal-footer .choose-bonus-intro');
			const $header = $modal.find('.modal-header');

			if ($intro.length && $header.length && !$header.find('.choose-bonus-intro').length) {
				$header.append($intro);
			}

			ensureBonusModalCloseIcon($modal);
			setBonusMaxQtyMessage(false);
			syncAllBonusQtySteppers($modal);
		})
		.on('hidden.bs.modal.lvzChooseBonusProduct', '#chooseBonusProductModal', function () {
			stopBonusModalLoader();
		});
}

/**
 * Select bonus product; show max-qty message when selection would exceed the allowance.
 */
base.selectBonusProduct = function () {
	$(document).on('click', '.select-bonus-product', function () {
		const $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
		const pid = $(this).data('pid');
		const maxPids = $('.choose-bonus-product-dialog').data('total-qty');
		const submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
		let totalQty = 0;
		$.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
			totalQty += $(this).data('qty');
		});
		totalQty += submittedQty;
		const optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
		const valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
		if (totalQty <= maxPids) {
			const selectedBonusProductHtml =
				'' +
				'<div class="selected-pid" ' +
				'data-pid="' +
				pid +
				'"' +
				'data-qty="' +
				submittedQty +
				'"' +
				'data-optionID="' +
				(optionID || '') +
				'"' +
				'data-option-selected-value="' +
				(valueId || '') +
				'"' +
				'>' +
				'<div class="bonus-product-name" >' +
				$choiceOfBonusProduct.find('.bonus-gift-card__name').html() +
				'</div>' +
				'<div class="bonus-product-delete"><i class="icon-close" aria-hidden="true"></i></div>' +
				'</div>';
			$('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
			$('.pre-cart-products').html(totalQty);
			setBonusMaxQtyMessage(false);
			syncAllBonusQtySteppers($('#chooseBonusProductModal'));
		} else {
			setBonusMaxQtyMessage(true);
		}
	});
};

/**
 * Remove a selected bonus product and clear the max-qty message.
 */
base.removeBonusProduct = function () {
	$(document).on('click', '.selected-pid', function () {
		$(this).remove();
		const $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
		let count = 0;
		if ($selected.length) {
			$selected.each(function () {
				count += parseInt($(this).data('qty'), 10);
			});
		}

		$('.pre-cart-products').html(count);
		setBonusMaxQtyMessage(false);
		syncAllBonusQtySteppers($('#chooseBonusProductModal'));
	});
};

bindBonusQtySteppers();
enhanceChooseBonusProductModal();

$('body').on('bonusproduct:updateSelectButton', function (e, response) {
	if (!response || !response.product || !response.$productContainer) {
		return;
	}
	const product = response.product;
	const $container = response.$productContainer;
	const resolvedImage = productImageResolver.resolveFromImageModel(product.images);

	if (resolvedImage) {
		$container.find('.bonus-gift-card__image').attr({
			src: resolvedImage.src,
			alt: resolvedImage.alt || product.productName || '',
			title: resolvedImage.title || product.productName || '',
		});
	}

	if (product.productName) {
		$container.find('.product-name, .bonus-gift-card__name').text(product.productName);
	}

	if (product.id) {
		$container
			.closest('.bonus-product-item')
			.attr('data-pid', product.id)
			.data('pid', product.id);
		$container.find('.select-bonus-product')
			.attr('data-pid', product.id)
			.data('pid', product.id);
	}
});

module.exports = base;
